import { useEffect, useRef, useCallback } from "react";
import { throttle, debounce } from "lodash";

// eslint-disable-next-line @typescript-eslint/ban-types
export default function useThrottle(cb: Function, delay: number) {
  const options = { leading: true, trailing: false }; // add custom lodash options
  const cbRef = useRef(cb);
  // use mutable ref to make useCallback/throttle not depend on `cb` dep
  useEffect(() => {
    cbRef.current = cb;
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(
    throttle((...args: any[]) => cbRef.current(...args), delay, options),
    [delay]
  );
}

// eslint-disable-next-line @typescript-eslint/ban-types
export function useDebounce(cb: Function, delay: number) {
  const options = { leading: false, trailing: true }; // add custom lodash options
  const cbRef = useRef(cb);
  // use mutable ref to make useCallback/throttle not depend on `cb` dep
  useEffect(() => {
    cbRef.current = cb;
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(
    debounce((...args: any[]) => cbRef.current(...args), delay, options),
    [delay]
  );
}
